import { mapValues, isObject, isPlainObject, isArrayLikeObject, forEach } from 'lodash-es'

const deep = (obj, mapper) => {
  return mapper(
    mapValues(obj, v => {
      let response = false
      let array = []
      if (isPlainObject(v)) {
        response = deep(v, mapper)
      } else if (isArrayLikeObject(v)) {
        forEach(v, value => {
          if (isObject(value)) {
            array.push(deep(value, mapper))
          } else {
            array.push(value)
          }
        })
        response = array
      } else {
        response = v
      }

      return response
    })
  )
}

export default deep
